import { render, staticRenderFns } from "./controllerSoftware.vue?vue&type=template&id=779472ea&scoped=true"
import script from "./controllerSoftware.vue?vue&type=script&lang=js"
export * from "./controllerSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779472ea",
  null
  
)

export default component.exports